import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
import { find, uniqueId, without } from 'lodash';
import i18n from 'plugins/i18n';
import { pinia } from 'plugins/store/index';

export const STATUS = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
};

interface IFlash extends Obj {
  queue: Array<FlashMessage>,
  status: Obj
}


const useStore = defineStore('flashmessage', () => {
  const state = ref<IFlash>({
    queue: [],
    status: STATUS,
  });

  // Actions
  /**
  * Spawn some message
  */
  const ADD = ({
    message, // your message - html or plain text
    title, // your message - html or plain text
    status = 'info', // eg STATUS top of this file
    duration = 5000, // ms - time before close - if 0/null no autoclose
    important = false, // if true, no close btn
  }: FlashMessage) => {
    const id: string = uniqueId('flash-message');
    
    const flash: FlashMessage = {
      id,
      status,
      important,
      message,
      title: title || i18n.global.t('LABELS.flash_title'),
    };

    // autoclose
    if (duration) {
      setTimeout(() => {
        DELETE(id);
      }, duration);
    }
    state.value.queue.push(flash);
  }

  /**
   * Remove a message from queue
   */
  const DELETE = (id:string) => {
    if (!id ) {
      throw new Error('[app] FLASH_REMOVE - missing message id');
    }
    const message = find(state.value.queue, { id });
    if (message) {
      state.value.queue = without(state.value.queue, message);
    }
  }

  return {
    state,

    //getters
    queue: computed( () => state.value.queue),
    status: computed( () => state.value.status),
  
    //actions
    ADD,
    DELETE,
  }
});

export const store = useStore(pinia);
export default store;
